module.exports = __webpack_public_path__ + "img/x-sync.24cbafc9.svg";